import { PsiService } from '@inversor-hub/types';

export const psiServiceLabels: Record<PsiService, string> = {
  OPPORTUNITY_SEARCH: 'Búsqueda/Gestión de oportunidad',
  TENANT_SEARCH: 'Búsqueda de inquilinos',
  REFURBISHMENT: 'Gestión de reforma',
  RENTAL_MANAGEMENT: 'Gestión del alquiler (anual)',
};

export const pricingModelLabels = {
  PACKAGE: 'Precio fijo por paquete',
  PER_SERVICE: 'Precio por servicio',
};
